import { render } from "./overview.vue?vue&type=template&id=aa279a72&scoped=true&ts=true"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"

import "./overview.vue?vue&type=style&index=0&id=aa279a72&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa279a72"]])

export default __exports__